import { ConstraintSpec } from '../../../../process/capability-spec/constraints/constraint-spec'

/**
 * This is a FE only class, used to configure constraints.
 */
export class ConstraintInput {
  constructor(
    public spec: ConstraintSpec,
    public values: string[] = [],
    public allowedValues: string[] = !!spec ? [...spec?.property?.values] : []
  ) {}
}
